import { create } from "zustand"
import { createClient } from "@/lib/supabase/client"

export interface PartnerLink {
  id: string
  name: string
  url: string
  display_name?: string
  favicon_url?: string
  description?: string
  category: string
  click_count: number
  is_active: boolean
  priority: number
  created_at: string
  updated_at: string
}

interface PartnerLinksStore {
  links: PartnerLink[]
  isLoading: boolean
  fetchLinks: () => Promise<void>
  trackClick: (linkId: string) => Promise<void>
}

export const usePartnerLinksStore = create<PartnerLinksStore>((set, get) => ({
  links: [],
  isLoading: false,

  fetchLinks: async () => {
    set({ isLoading: true })
    try {
      const supabase = createClient()
      const { data, error } = await supabase
        .from("partner_links")
        .select("*")
        .eq("is_active", true)
        .order("priority", { ascending: false })

      if (error) throw error

      set({ links: data || [] })
    } catch (error) {
      console.error("[v0] Failed to fetch partner links:", error)
      set({ links: [] })
    } finally {
      set({ isLoading: false })
    }
  },

  trackClick: async (linkId: string) => {
    try {
      const supabase = createClient()
      const {
        data: { user },
      } = await supabase.auth.getUser()

      set((state) => ({
        links: state.links.map((link) => (link.id === linkId ? { ...link, click_count: link.click_count + 1 } : link)),
      }))

      await supabase.from("partner_link_clicks").insert({
        link_id: linkId,
        user_id: user?.id || null,
        referrer: typeof window !== "undefined" ? window.location.href : null,
        user_agent: typeof navigator !== "undefined" ? navigator.userAgent : null,
      })

      console.log("[v0] Tracked click for link:", linkId)
    } catch (error) {
      console.error("[v0] Failed to track click:", error)
    }
  },
}))
